import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import SvgIcon from "@mui/material/SvgIcon";

import GroheRoomLayoutsContent from "./groheRoomLayoutsContent";
import {FormattedMessage} from "react-intl";
import {ROUTES} from "../../../../routes";
import MaterialSpinner from "../../../ui/materialSpinner";
import {LookLayoutIcon} from "../../../common/icons";
import COLOR_THEMES, {COLORS} from "../../../../colorThemes";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {setLookPageOpened} from "../../../../actions/lookFunctions";
import GroheRoomIdeasContent from "../groheRoomIdeas/groheRoomIdeasContent";
import {isRoomLayoutsVisible} from "../../lookNavigation/lookNavigationFunctions";


const GroheRoomLayouts = (props) => {

  const {lookPageOpened, isMobile, visualizersLoadedLength, activeTheme, setLookPageOpened, history} = props;
  const layoutsOpened = lookPageOpened === ROUTES.view || lookPageOpened === ROUTES.rooms;
  const [allowRender, setAllowRender] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setAllowRender(true);
    }, 100)
  }, [])

  const roomLayoutsButtonClick = (roomButton) => {
    let analyticsEvent = roomButton === ROUTES.view
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.roomsRoomLayouts
      : PRODUCT_JOURNEY_ANALYTIC_EVENTS.roomsRoomIdeas
    Analytics.sendClickEvent(analyticsEvent);
    setLookPageOpened(roomButton);
    history.push(roomButton);
  }

  return (
    <section className={"grohe-section" + (layoutsOpened ? " grohe-section--opened" : "")}>
      {isMobile ? null : (
        <h2 className="grohe-section__title">
          <FormattedMessage id="look.layout.header.title"/>
        </h2>
      )}
      {isMobile ? null : (
        <p className="grohe-section__description">
          <FormattedMessage id="look.layout.header.subTitle"/>
        </p>
      )}
      {isMobile || !isRoomLayoutsVisible() ? null : (
        <div className="grohe-section__buttons">
          {[ROUTES.view, ROUTES.rooms].map(buttonKey => {
            const isActive = lookPageOpened === buttonKey;
            const buttonIcon = buttonKey === ROUTES.view ? (
              <SvgIcon>
                <LookLayoutIcon color={isActive ? COLORS.white : COLOR_THEMES[activeTheme].primary}/>
              </SvgIcon>
            ) : <EmojiObjectsIcon/>;
            const translate = buttonKey === ROUTES.view ? "buttons.roomLayouts" : "buttons.roomIdeas";
            return (
              <Button className={"grohe-look__button look-button " + (isActive ? "look-button--primary" : "look-button--secondary")}
                      key={buttonKey}
                      startIcon={buttonIcon}
                      onClick={() => roomLayoutsButtonClick(buttonKey)}>
                <FormattedMessage id={translate}/>
              </Button>
            )
          })}
        </div>
      )}
      {!visualizersLoadedLength
        ? <MaterialSpinner/>
        : layoutsOpened && allowRender
          ? lookPageOpened === ROUTES.view ? <GroheRoomLayoutsContent/> : <GroheRoomIdeasContent/>
          : null}
    </section>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened} = store.lookState;
  const {isMobile, visualizersLoaded, activeTheme} = store.serverState;
  return {
    lookPageOpened,
    isMobile,
    activeTheme,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheRoomLayouts)
)
